import { o_util } from "@gr-common/async/namespaces";
const toggle = o_util.toggle ?? {};
const get = toggle.get;
const getToggle = toggle.getToggle;
export {
  get,
  getToggle,
  toggle
};
